import { TaskStatuses } from "enums/taskStatuses";

export const getTaskRejectReason = (record: any) =>
  record?.taskStatus === TaskStatuses.REJECTED
    ? record?.taskHistoryRecords?.[record?.taskHistoryRecords?.length - 1]?.text
    : null;
